import sensors from 'sa-sdk-javascript';
console.log(process.env.VUE_APP_SERVERURL)
sensors.init({ // 神策系统配置
    server_url: 'https://sc8106.ssish.com/sa?project=' + (process.env.VUE_APP_SERVERURL || 'default'),
    is_track_single_page: true, // 单页应用页面浏览事件采集(url改变就触发)
    show_log: true,
    heatmap: { // 热图设置 default开启 not_collect关闭（详细配置解释看官方文档）
      clickmap: 'default', // 点击热图，收集点击事件
      scroll_notice_map: 'default', // 视区热图，收集页面区域停留时间
      collect_tags: {
            div: {
                ignore_tags: ['span', 'mark', 'strong', 'b', 'em', 'i', 'u', 'abbr', 'ins', 'del', 's', 'sup']
            }
        }
    }
})
sensors.quick('autoTrack') // 首次触发页面加载事件 $pageview

function getSensorsUrlPath(){
	var url = document.location.toString();
	var arrUrl = url.split("//");
	var start = arrUrl[1].indexOf("/");
	var relUrl = arrUrl[1].substring(start);
	if(relUrl.indexOf("?") != -1){
		relUrl = relUrl.split("?")[0];
	}
	return relUrl;
}
function getUrlParams(name) {
	var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)"); //构造一个含有目标参数的正则表达式对象
	var r = window.location.search.substr(1).match(reg);  //匹配目标参数
	if (r != null) return unescape(r[2]); return null; //返回参数值
}

export function sensorsEvent(params) {
    sensors.quick('autoTrack') // 首次触发页面加载事件 $pageview
    // let href = window.location.href;
    
    // sensors.track('', {
    //     $url: href,
    //     $url_path: getSensorsUrlPath(),
    //     $referrer: document.referrer,
    //     $title: document.title,
    //     host: document.domain,
    //     platform_name:'mediLink-official',
    // });
}